import { HttpClient, HttpContext } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { ThirdPartyRequest} from "../interfaces/third-party-add-item.interface";
import { ThirdPartyItem} from "../interfaces/third-party-item.interface";
import { HttpContextTokens, HttpLoggingOptions } from "common";

const sharedUrl = '/senderidregistry/manage/third-party';

@Injectable({
  providedIn: 'root',
})
export class ThirdPartiesApiService {
  http = inject(HttpClient);

  private httpContext: HttpContext = null;

  constructor() {
    this.initialiseHttpContext();
  }

  private initialiseHttpContext(): void {
    if (this.httpContext === null) {
      this.httpContext = new HttpContext();

      var httpLoggingOptions = new HttpLoggingOptions();
      
      this.httpContext.set(HttpContextTokens.options, httpLoggingOptions);
    }
  }

  public getThirdParties$(){
    return this.http.get<ThirdPartyItem[]>(`${sharedUrl}`);
  }

  public addThirdParty$(data: ThirdPartyRequest) {
    return this.http.post(`${sharedUrl}`, data , { context: this.httpContext });
  }
}
 